import { Box } from '@material-ui/core';
import React from 'react';
import { FixedTab, RouteTabs } from '../../components/RouteTabs';
import { RouteNames } from '../config';
import SaleStoryCreate from './SaleStoryCreate';
import SaleStoryList from './SaleStoryList';

const SaleStory = (): JSX.Element => {
  const path = RouteNames.SaleStoryScheduling;

  return (
    <Box>
      <RouteTabs path={path}>
        <FixedTab label="All Schedules">
          <SaleStoryList />
        </FixedTab>
        <FixedTab label="Create a Schedule" uri="create">
          <SaleStoryCreate />
        </FixedTab>
      </RouteTabs>
    </Box>
  );
};

export default SaleStory;
